export interface ReportCategory {
  categoryId: number;
  categoryName: string;
  children: ReportCategory[];
}

export enum ReportStatus {
  NOT_YET = 0,
  BANNED = 1,
  OMMITTED = 2,
}

export interface Report {
  reportId: number;
  imageUrl: string;
  userRemark: string;
  categoryId: string;
  subCategoryId: string;
  artworkId: string;
  status: ReportStatus;
  type?: number; // 1 话题 0 作品
  createTime: string;
  updateUserName?: string;
  updateTime?: string;
  // 举报人 / 被举报人的昵称与姓名（列表接口返回）
  reportUserNickName?: string;
  reportUserName?: string;
  theReportUserNickName?: string;
  theReportUserName?: string;
}

export interface ReportListQuery {
  artworkId?: string;
  reportId?: string;
  categoryId?: string;
  subCategoryId?: string;
  reportUserId?: string;
  type?: number; // 1 话题 0 作品
  pageSize?: number;
  currentPage?: number;
}

export interface ReportList {
  total: number;
  currentPage: number;
  pageSize: number;
  records: Report[];
}

export interface ReportDetail {
  reportId: number;
  status: ReportStatus;
  imageUrls: string[];
  userRemark: string;
  categoryId: string;
  subCategoryId: string;
  artworkId: string;
  createTime: string;
  conclusion: string;
  artworkTitle: string;
  artworkDescription: string;
  artworkImageUrls: string[];
  reportUserId: string;
  reportUserName: string;
  reportUserNickName: string;
  userNumber: string;
  // 被举报人（违规作者）的 SuppId，接口返回
  theReportUserId: string;
}

export type ReportAuditResult = 'approve' | 'reject';

export interface ReportAudit {
  reportId: number | string;
  auditResult: ReportAuditResult;
  conclusion?: string;
  type?: number; // 1 话题 0 作品（列表带入）
}
